import { Dialog, Transition } from '@headlessui/react'
import { Fragment } from 'react'

const PopupModal = (props) => {
    const { data, isPopupOpen, setIsPopupOpen } = props;

    function closeModal() {
        setIsPopupOpen(false)
    }

    return (
        <Transition appear show={isPopupOpen} as={Fragment}>
            <Dialog as="div" className="relative z-50" onClose={closeModal}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-primary bg-opacity-80" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-bg_league bg-opacity-95 p-6 pb-3 text-left align-middle shadow-xl transition-all">
                                <Dialog.Title
                                    as="h3"
                                    className="text-md font-bold leading-6 text-primary"
                                >
                                    Announcement
                                </Dialog.Title>
                                <div className="mt-1">
                                    {
                                        data?.map((d, index) => (
                                            <div key={index} className='text-sm text-primary'>{d?.displayText}</div>
                                        ))
                                    }
                                </div>
                                <div className="mt-4 w-full flex justify-end">
                                    <button
                                        type="button"
                                        className="inline-flex justify-center rounded-md border border-transparent bg-primary px-4 py-2 text-sm font-normal text-white "
                                        onClick={closeModal}
                                    >
                                        CLOSE
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    )
}

export default PopupModal